import type { JSX } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProductCertificateTypeProps } from './types';

export const ProductCertificateType = ({
  certificateType,
}: ProductCertificateTypeProps) => {
  const renderCertificateType = (): JSX.Element | null => {
    switch (certificateType) {
      case 'professional':
      case 'no-id-professional':
        return (
          <FormattedMessage
            id="payment.product.line.item.professional.certificate"
            defaultMessage="Professional Certificate"
            description="Course certificate type on product details section"
          />
        );
      case 'verified':
        return (
          <FormattedMessage
            id="payment.product.line.item.verified.certificate"
            defaultMessage="Verified Certificate"
            description="Course certificate type on product details section"
          />
        );
      case 'credit':
        return null;
      case 'honor':
      case 'audit':
      default:
        return (
          <FormattedMessage
            id="payment.product.line.item.verified.certificate"
            defaultMessage="Verified Certificate"
            description="Course certificate type on product details section"
          />
        );
    }
  };

  return <p className="m-0">{renderCertificateType()}</p>;
};
